import { render, staticRenderFns } from "./OverviewMisc.vue?vue&type=template&id=6f3c067e&scoped=true"
import script from "./OverviewMisc.vue?vue&type=script&lang=js"
export * from "./OverviewMisc.vue?vue&type=script&lang=js"
import style0 from "./OverviewMisc.vue?vue&type=style&index=0&id=6f3c067e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3c067e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3c067e')) {
      api.createRecord('6f3c067e', component.options)
    } else {
      api.reload('6f3c067e', component.options)
    }
    module.hot.accept("./OverviewMisc.vue?vue&type=template&id=6f3c067e&scoped=true", function () {
      api.rerender('6f3c067e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/OverviewMisc.vue"
export default component.exports